module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/logo_vgu-c05c9c5a5fa6e3dffed5d91aeec06683.svg";